import React from "react";
import {
  BooleanField,
  Datagrid,
  DateField,
  List,
  ReferenceField,
  TextField,
} from "react-admin";

export const getPneus = (props) => {
  console.log("props", props.data);
  return (
    <List {...props} exporter={false} sort={{ field: "id", order: "DESC" }}>
      <Datagrid>
        <TextField source="id" />
        <ReferenceField source="moteurId" reference="Moteurs">
          <TextField source="id" />
        </ReferenceField>
        <ReferenceField source="tracteId" reference="Tractes">
          <TextField source="id" />
        </ReferenceField>
        <TextField source="positionPneuId" />
        <TextField source="pressionRelevee" />
        <TextField source="pressionRecommandee" />
        <BooleanField source="pressionAnormale" />
        <TextField source="temperatureRelevee" />
        <TextField source="temperatureRecommandee" />
        <BooleanField source="temperatureAnormale" />
        <DateField source="dateReleve" showTime />
        <DateField source="createdAt" showTime />
        <DateField source="updatedAt" showTime />
      </Datagrid>
    </List>
  );
};
